module.exports = __webpack_public_path__ + "static/media/waterfalls.d882666f.jpg";